module.exports = require('./helpers/bundle-url').getBundleURL('cqLDD') + "widget-icon.610492aa.png";